'use client';

import { signOut } from 'next-auth/react';

import { Button } from '@/components/Button/Button';
import { env } from '@/utils/env/env';

export const ExitRetailerButton = ({ exitLabel, link, variant }: { exitLabel: string; link: string; variant: 'navbar' | 'secondary' }) => {
	async function handleSignOut() {
		// Using the following method to logout https://learn.microsoft.com/en-us/entra/identity-platform/scenario-web-app-sign-user-sign-in?tabs=nodejs#sign-out
		await signOut({ callbackUrl: `https://login.microsoftonline.com/${env('PUBLIC_AZURE_AD_TENANT_ID')}/oauth2/v2.0/logout?post_logout_redirect_uri=${document.location.origin + link}` });
	}

	return (
		<Button variant={variant} icon="exit" iconPosition="left" iconSize="1em" onClick={() => handleSignOut()}>
			{exitLabel}
		</Button>
	);
};
